<template>
  <Modal :title="title" @hide-modal="emit('cancel')">
    <div>
      This {{ itemType }} will be permanently deleted and you will not be able
      to undo this action. Are you sure?
    </div>
    <template #submit>
      <SeraButton id="submit_modal_btn" type="danger" @click="emit('confirm')">
        Remove {{ itemType }}
      </SeraButton>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SeraButton from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";

const props = withDefaults(
  defineProps<{
    itemType?: string;
  }>(),
  {
    itemType: "Item"
  }
);

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

const title = computed(() => `Remove ${props.itemType}`);
</script>
